import { addIncomeAndExpenses, deleteIncomeAndExpensesById, getAllIncomeAndExpenses, getIncomeAndExpensesById, updateIncomeAndExpenses, } from "../../../helpers/backend_helper";
import { incomeAndExpensesError, incomeAndExpensesRequest, incomeAndExpensesSuccess } from "./reducer";

export const fetchIncomeAndExpenses = (page:number,count:number,keyword?:string) => async (dispatch: any) => {
    dispatch(incomeAndExpensesRequest());
    try {
      const response: any = await getAllIncomeAndExpenses(page,count,keyword);
      if (response && response.isSuccess) {
        dispatch(incomeAndExpensesSuccess(response.data));
        return response
      } else {
        dispatch(incomeAndExpensesError("Failed to fetch reminder"));
        return response
      }
    } catch (error: any) {
      dispatch(incomeAndExpensesError(error.message));
      return null
      
    }
  };

export const fetchIncomeAndExpensesById = (id: string) => async (dispatch: any) => {
  dispatch(incomeAndExpensesRequest());
  try {
    const response: any = await getIncomeAndExpensesById(id);
    if (response && response.isSuccess) {
      dispatch(incomeAndExpensesSuccess(response.data));
      return response
    } else {
      dispatch(incomeAndExpensesError("Failed to fetch reminder"));
      return response
    }
  } catch (error: any) {
    dispatch(incomeAndExpensesError(error.message));
    return null
  }
}

export const addIncomes = (data: any) => async (dispatch: any) => {
  dispatch(incomeAndExpensesRequest());
  try {
    const response: any = await addIncomeAndExpenses(data);
    if (response && response.isSuccess) {
      dispatch(incomeAndExpensesSuccess(response.data));
      return response
    } else {
      dispatch(incomeAndExpensesError("Failed to fetch reminder"));
      return response
    }
  } catch (error: any) {
    dispatch(incomeAndExpensesError(error.message));
    return null
  }
}

export const updateIncome = (data: any) => async (dispatch: any) => {
  dispatch(incomeAndExpensesRequest());
  try {
    const response: any = await updateIncomeAndExpenses(data);
    if (response && response.isSuccess) {
      dispatch(incomeAndExpensesSuccess(response.data));
      return response
    } else {
      dispatch(incomeAndExpensesError("Failed to fetch reminder"));
      return response
    }
  } catch (error: any) {
    dispatch(incomeAndExpensesError(error.message));
    return null
  }
}
export const deleteIncome = (id: string) => async (dispatch: any) => {
  dispatch(incomeAndExpensesRequest());
  try {
    const response: any = await deleteIncomeAndExpensesById(id);
    if (response && response.isSuccess) {
      dispatch(incomeAndExpensesSuccess(response.data));
      return response
    } else {
      dispatch(incomeAndExpensesError("Failed to fetch reminder"));
      return response
    }
  } catch (error: any) {
    dispatch(incomeAndExpensesError(error.message));
    return null
  }
}
